import React from 'react';
import { Mic, MicOff, PhoneOff, Maximize2 } from 'lucide-react';

// The minimized call: a small persistent bar (bottom-right, any screen, any
// page) while the command center is tucked away. The call keeps running in
// the provider; this is just the handle.

const formatDuration = (ms) => {
  const s = Math.floor(ms / 1000);
  const mm = Math.floor(s / 60);
  const ss = s % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(mm)}:${pad(ss)}`;
};

const CallDock = ({
  call,
  muted,
  elapsedMs,
  onToggleMute,
  onRestore,
  onHangup,
}) => (
  <div className="fixed bottom-4 right-4 z-[1090] flex items-center gap-2 rounded-full border border-slate-200 bg-white py-1.5 pl-3.5 pr-1.5 shadow-[0_4px_20px_rgba(15,23,42,0.18)] dark:border-white/10 dark:!bg-surface-elevated">
    <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" />
    <button
      type="button"
      onClick={onRestore}
      title="Back to the call center"
      className="text-left"
    >
      <span className="block max-w-[10rem] truncate text-xs font-semibold text-slate-800 dark:text-slate-100">
        {call.lead.leadFirstName} {call.lead.leadLastName}
      </span>
      <span className="block text-[10px] text-slate-400">
        {call.contactMade ? 'Contact made' : 'On the call'} ·{' '}
        {formatDuration(elapsedMs)}
      </span>
    </button>
    <button
      type="button"
      onClick={onToggleMute}
      title={muted ? 'Unmute' : 'Mute'}
      className={`rounded-full p-2 ${
        muted
          ? 'bg-amber-100 text-amber-700'
          : 'bg-slate-100 text-slate-500 hover:bg-slate-200 dark:bg-white/10 dark:text-slate-300'
      }`}
    >
      {muted ? <MicOff size={13} /> : <Mic size={13} />}
    </button>
    <button
      type="button"
      onClick={onRestore}
      title="Open the call center"
      className="rounded-full bg-slate-100 p-2 text-slate-500 hover:bg-slate-200 dark:bg-white/10 dark:text-slate-300"
    >
      <Maximize2 size={13} />
    </button>
    <button
      type="button"
      onClick={onHangup}
      title="Hang up"
      className="rounded-full bg-red-600 p-2 text-white hover:bg-red-500"
    >
      <PhoneOff size={13} />
    </button>
  </div>
);

export default CallDock;
